//2 React components that resemble a dropdown menu and the cooresponding items in the dropdown
import {secondary, hexToRGBA} from "./Globals";
import Button from "@mui/material/Button";
import React from "react";
import './DropDown.css';
import {useTheme} from "@mui/material";

const DropDown = (props) => {
    return (
        <div
            className="dropDown flex flex-col bg-neutral-300 dark:bg-neutral-900 px-4 py-1 z-10 absolute top-12 rounded border-2 border-neutral-900">
            {props.children}
        </div>
    )
}

const DropDownItem = (props) => {
    DropDownItem.defaultProps = {
        toggable: false,
        disabled: false,
    }
    const currentTheme = useTheme();
    return (
        <div className="py-1">
            <Button startIcon={props.leftIcon} onClick={props.onClick}
                    style={
                        props.toggable ? {
                        color: props.isActive ? hexToRGBA(currentTheme.palette.secondary.main, 0.8) : ''
                    } : {}
                    }
                    disabled={props.disabled}
                    variant="text" color="textColor" size="small">{props.name}
                {props.children}
            </Button>

        </div>
    )
}

export {DropDown, DropDownItem};